import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { useValidationService } from "../../../../../services/hooks/index.js";
import { Dialog, DialogContent } from "../../../../../Dialog/index.js";
import { Button } from "../../../../../Button/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Box } from "../../../../../Box/index.js";
import { FileInput, TextInput } from "../../../../index.js";
import { useForm } from "../../hooks/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const MIN_IMAGE_WIDTH = 160;
const MIN_IMAGE_HEIGHT = 90;
const AddImageDialog = ({ open, onClose, addImage })=>{
    const [image, setImage] = useState();
    const [description, setDescription] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const validator = useValidationService();
    const allValues = useMemo(()=>({
            image
        }), [
        image
    ]);
    const fieldValidators = useMemo(()=>({
            image: [
                validator.required(),
                validator.sizeLimit('Загрузите файл jpeg, png, webp, tiff, dng или heif до 10МБ', {
                    field: "image",
                    sizeLimit: 10
                }),
                validator.requiredIfFile('Загрузите файл jpeg, png, tiff, webp, dng или heif до 10МБ', {
                    field: 'image',
                    fileTypes: [
                        'image/jpeg',
                        'image/png',
                        'image/heif',
                        'image/heic',
                        'image/webp',
                        'image/dng',
                        'image/tiff'
                    ]
                }),
                validator.imageResolutionCheck(`Размер изображения не может быть меньше ${MIN_IMAGE_WIDTH} x ${MIN_IMAGE_HEIGHT}`, {
                    minWidth: MIN_IMAGE_WIDTH,
                    minHeight: MIN_IMAGE_HEIGHT
                })
            ]
        }), [
        validator
    ]);
    const { errors, touched, validateField, hasValidationErrors, showError } = useForm(allValues, fieldValidators);
    const handleChangeImageInput = (value)=>_async_to_generator(function*() {
            setImage(value);
            yield validateField('image', value);
            showError('image');
        })();
    const handleChangeDescriptionInput = (value_0)=>{
        setDescription(()=>value_0 || '');
    };
    const handleSubmit = ()=>_async_to_generator(function*() {
            setIsSubmitting(true);
            try {
                if (image) yield addImage(image, description);
            } finally{
                setIsSubmitting(false);
                onClose();
            }
        })();
    return /*#__PURE__*/ jsx(Dialog, {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ jsx("form", {
            onSubmit: handleSubmit,
            children: /*#__PURE__*/ jsx(DialogContent, {
                title: "Добавление изображения",
                onClose: onClose,
                actions: /*#__PURE__*/ jsxs(Fragment, {
                    children: [
                        /*#__PURE__*/ jsx(Button, {
                            variant: "tertiaryLight",
                            size: "large",
                            onClick: onClose,
                            disabled: isSubmitting,
                            children: "Отменить"
                        }),
                        /*#__PURE__*/ jsx(Button, {
                            type: "submit",
                            variant: "primary",
                            size: "large",
                            disabled: hasValidationErrors || isSubmitting,
                            loading: isSubmitting,
                            children: "Добавить"
                        })
                    ]
                }),
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    flexDirection: "column",
                    gap: "24",
                    children: [
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "body1",
                            color: "text.light.secondary",
                            children: "Отображаться изображения будут в соотношении сторон 16:9"
                        }),
                        /*#__PURE__*/ jsxs(Box, {
                            display: "flex",
                            flexDirection: "column",
                            gap: "8",
                            children: [
                                /*#__PURE__*/ jsx(FileInput, {
                                    fullWidth: true,
                                    required: true,
                                    value: image,
                                    label: "Изображение",
                                    placeholder: "Загрузите файл jpeg, png, tiff, webp, dng или heif до 10МБ",
                                    helperText: "Размер изображения от 160 \xd7 90 пикселей",
                                    onChange: handleChangeImageInput,
                                    error: touched.image && !!errors.image,
                                    errorText: touched.image ? errors.image : void 0
                                }),
                                /*#__PURE__*/ jsx(TextInput, {
                                    name: "description",
                                    label: "Подпись",
                                    placeholder: "Подпись к изображению",
                                    onChange: handleChangeDescriptionInput
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
export { AddImageDialog };
